export var TOCBUYORSELL;
(function (TOCBUYORSELL) {
    TOCBUYORSELL["BUY"] = "Buy";
    TOCBUYORSELL["SELL"] = "Sell";
    TOCBUYORSELL["SIP"] = "SIP";
    TOCBUYORSELL["GTT"] = "GTT";
})(TOCBUYORSELL || (TOCBUYORSELL = {}));
export var TOCOrderType;
(function (TOCOrderType) {
    TOCOrderType["MARKET"] = "MARKET";
    TOCOrderType["LIMIT"] = "LIMIT";
    TOCOrderType["SL"] = "SL";
})(TOCOrderType || (TOCOrderType = {}));
export var TOCProductCode;
(function (TOCProductCode) {
    TOCProductCode["CNC"] = "CNC";
    TOCProductCode["MIS"] = "MIS";
    TOCProductCode["NRML"] = "NRML";
    TOCProductCode["MTF"] = "MTF";
    TOCProductCode["BO"] = "BO";
})(TOCProductCode || (TOCProductCode = {}));
export var TOCValidationCode;
(function (TOCValidationCode) {
    TOCValidationCode["DAY"] = "DAY";
    TOCValidationCode["IOC"] = "IOC";
    TOCValidationCode["GTC"] = "GTC";
})(TOCValidationCode || (TOCValidationCode = {}));
export const EQTOCIgnoreList = ["CO", "GTC", "GTD", "STOP_MARKET"];
export const FNOTOCIgnoreList = [
    "CO",
    "MTF",
    "GTC",
    "GTD",
    "CNC",
    "STOP_MARKET",
];
export const COMMTOCIgnoreList = [
    "CO",
    "MTF",
    "BO",
    "GTC",
    "GTD",
    "CNC",
    "STOP_MARKET",
];
export const SIPIgnoreList = ["CO", "BO", "MTF", "GTC", "GTD", "MIS"];
export const CURRENCYIgnoreList = [
    "CO",
    "MTF",
    "GTC",
    "GTD",
    "CNC",
    "STOP_MARKET",
];
export const NCDIgnoreList = [
    "CO",
    "BO",
    "MTF",
    "GTC",
    "GTD",
    "NRML",
    "MIS",
    "STOP_LIMIT",
    "STOP_MARKET",
];
